import * as yup from "yup";
const phoneValidation = yup.object().shape({
  phone: yup.string().min(10).required("يرجى إدخال رقم الهاتف"),
});

export { phoneValidation };
